import React, {useEffect, useState} from 'react';
import classes from './Experience.css'
import Container from '../../../hoc/Container/Container';
import axios from '../../../firebase-axios';
const experience = () => {
    const [state,setState] = useState({experience:[]})
    let experienceList = [] 
    useEffect(() =>{
        axios.get('experience.json')
        .then((res) => {
            let expRes = [];
            for(const key in res.data) {
                expRes.push({
                    id:key,
                    ...res.data[key]
                })
            }
            setState({experience:expRes})
        })
        .catch((err) => {
            alert('Something went wrong');
            console.log(err);
        });
    },[]);
    if(state.experience.length != 0) {
        experienceList = state.experience.map((exp) => {
            return (
                <li key={exp.id} className={classes.expContainer} >
                    <div className={classes.expCount}>{exp.position?exp.position:null}</div>
                    <div  className={classes.expDesc}>
                    <div className={classes.cmpTag}><span>Company Name:</span>{exp.companyName?exp.companyName:null}</div>
                    <div className={classes.cmpTag}><span>Working Period:</span>{exp.workingPeriod && exp.workingPeriodUnit?(exp.workingPeriod + ' '+ exp.workingPeriodUnit):null}</div>
                    <div className={classes.cmpTag}><span>Description</span></div>
                        <div className={classes.compDesc}>
                        {exp.description?exp.description:null}
                        </div>
                     </div>
                </li>
            )
        })
    } 
    return (<section id="experience" className={classes.experience+' '+ 'appMTop30' }  >
            <h2 className="site-section-title">Experience</h2>
        <Container>
            <ul className={classes.appStyledGrid+' appPYx'}>
                {experienceList}
            </ul>
        </Container>
    </section>);
};

export default experience;


// WEBPACK FOOTER //
// ./src/components/Sections/Experience/Experience.js